import React from "react";
import styled from "styled-components";

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
    line-height: 16px;
  color: gray;

  &[data-checked="true"] {
    color: var(--text-color);}

  
`;

const RadioInput = styled.input.attrs({ type: "radio" })`
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid rgba(31, 31, 31, 1);
  background-color: rgba(14, 14, 16, 1);
  border-radius: 50%;
  margin-right: 8px;
  margin-left: 0;
  position: relative;
  cursor: pointer;

  &:checked {
  border-color: var(--text-active-color);}

  &:checked::after {
    content: "";
    position: absolute;
    top: 4.25px;
    left: 4.25px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: var(--text-active-color);
  }
`;


interface RadioOption<T extends string> {
  value: T;
  label: string;
}
interface AcceptanceRadioProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: RadioOption<T>[]; // список вариантов
}
export function AcceptanceRadio<T extends string>({
  value,
  onChange,
  options,
}: AcceptanceRadioProps<T>) {
  return (
    <RadioGroup>
      {options.map((opt) => (
        <RadioLabel key={opt.value} data-checked={value === opt.value}>
          <RadioInput
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
          />
          {opt.label}
        </RadioLabel>
      ))}
    </RadioGroup>
  );
}